import { Component, OnInit, Input, ViewChild, ElementRef, AfterViewInit, Output, EventEmitter } from '@angular/core';
import echarts from 'echarts';
@Component({
    selector: 'app-report',
    templateUrl: './report.component.html',
    styleUrls: ['./report.component.scss']
})
export class ReportComponent implements OnInit, AfterViewInit {
    @ViewChild('report', {static: true})
    public reportDom: ElementRef;
    public viewInit: boolean;
    public echart: any;
    public config: any = {
        xAxis: {
            type: 'category',
            data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        },
        yAxis: {
            type: 'value'
        },
        series: [{
            data: [820, 932, 901, 934, 1290, 1330, 1320],
            type: 'line'
        }]
    };
    @Input()
    public eventName: string[] | string;

    @Output()
    public bindAction: EventEmitter<any> = new EventEmitter();

    @Input()
    public set data(data: any) {
        this.config = data;
        this.init();
    }

    public constructor() {
        //
    }

    public ngOnInit() {
        //
    }

    public ngAfterViewInit(): void {
        this.viewInit = true;
        this.init();
    }

    public init() {
        if (this.viewInit) {
            this.echart = echarts.init(this.reportDom.nativeElement);
            this.echart.setOption(this.config);
            if (this.eventName) {
                if (Array.isArray(this.eventName)) {
                    this.eventName.forEach(
                        x => {
                            this.echart.on(x, (params) => {
                                this.bindAction.emit(params);
                            });
                        }
                    );
                } else {
                    this.echart.on(this.eventName, (params) => {
                        this.bindAction.emit(params);
                    });
                }
            }
        }

    }
}
